export default "__VITE_ASSET__d15b24de__"